import { take, call, put, takeLatest } from 'redux-saga/effects'

import * as projectsModule from '../reducks/projects'

import * as projectsApi from '../apiModules/projects'

function* createProjectsSaga(action) {
  if (action.payload.data.id) {
    return yield put(projectsModule.updateProject(action.payload.data.id, action.payload.data))
  }

  const uploadChannel = yield call(projectsApi.createProjectChannel, action.payload.id, action.payload.data)

  while (true) {
    const { progressEvent = {}, response = {} } = yield take(uploadChannel)

    if (progressEvent.lengthComputable) {
      yield put(
        projectsModule.updateProgress({
          index: action.payload.data.index,
          isUploading: true,
          progress: (parseFloat(progressEvent.loaded) / parseFloat(progressEvent.total)) * 100,
        }),
      )
    }

    if (response.success) {
      yield put(projectsModule.createProjectSuccess(response.result))
      yield put(
        projectsModule.updateProgress({
          index: null,
          isUploading: false,
          progress: 0,
        }),
      )
    }
  }
}

function* fetchProjectsSaga(action) {
  try {
    const response = yield projectsApi.fetchProjects(action.payload.id)
    yield put(projectsModule.fetchProjectSuccess(response))
  } catch (error) {}
}

function* updateProjectsSaga(action) {
  const uploadChannel = yield call(projectsApi.updateProjectChannel, action.payload.id, action.payload.data)

  while (true) {
    const { progressEvent = {}, response = {} } = yield take(uploadChannel)

    if (progressEvent.lengthComputable) {
      yield put(
        projectsModule.updateProgress({
          index: action.payload.data.index,
          isUploading: true,
          progress: (parseFloat(progressEvent.loaded) / parseFloat(progressEvent.total)) * 100,
        }),
      )
    }

    if (response.success) {
      yield put(projectsModule.updateProjectSuccess(response.result))
      yield put(
        projectsModule.updateProgress({
          index: null,
          isUploading: false,
          progress: 0,
        }),
      )
    }
  }
}

function* deleteProjectsSaga(action) {
  try {
    yield projectsApi.deleteProject(action.payload.id)
    yield put(projectsModule.fetchProjects(action.payload.candidateId))
  } catch (error) {}
}

export default function* watchProjectsSaga() {
  yield takeLatest(projectsModule.CREATE, createProjectsSaga)
  yield takeLatest(projectsModule.FETCH, fetchProjectsSaga)
  yield takeLatest(projectsModule.UPDATE, updateProjectsSaga)
  yield takeLatest(projectsModule.DELETE, deleteProjectsSaga)
}
